import React from "react";
import { useLocalization } from "@fluent/react";
import { IconButton } from "@narmi/design_system";
import { ContentCard } from "cerulean";

import styles from "./CardOffers.module.scss";

interface CardOffersProps {
  card: API.Card;
}

const CardOffers = ({ card }: CardOffersProps) => {
  const { l10n } = useLocalization();

  return (
    <a href={`/cards/${card.id}/offers`}>
      <div className={styles.cardOffersContainer}>
        <ContentCard>
          <div className={styles.offersContainer}>
            <div className={styles.iconContainer}>
              <span className={styles.icon}>💰</span>
            </div>
            <div className={styles.contentContainer}>
              <div className={styles.titleContainer}>
                <span className={styles.title}>
                  {l10n.getString(
                    "card-feature-offers",
                    null,
                    "Available offers"
                  )}
                </span>
              </div>
              <p
                className={`fontColor--secondary fontSize--s ${styles.description}`}
              >
                {l10n.getString(
                  "card-feature-offers-description",
                  null,
                  "Get cash back on brands you love. Tap to browse your personalized offers."
                )}
              </p>
            </div>
            <span aria-hidden="true" className={styles.arrowContainer}>
              <IconButton name="arrow-right" kind="plain" textSize="l" />
            </span>
          </div>
        </ContentCard>
      </div>
    </a>
  );
};

export default CardOffers;
